import { IComponentTemplate, RecipeUGC, ToolkitOptions } from "@/store/modules/recipe/recipe.t";
import { GraphicComponentTypes, IGraphicGDM } from "./types/Graphics.t";
import store from "@/store";

const getSwatchSubgroup = (swatchId: number | string) => {
    const swatch = store.getters["swatches/returnSwatchObj"]({ swatchId });
    return store.getters['swatches/returnSwatchSubgroupName']({ swatch });
}

const RecipeCreateFromGDM = (
    graphic: IGraphicGDM,
    forceUGC: boolean = false,
    ugc?: RecipeUGC,
    toolkitOptions?: ToolkitOptions,
    ugcComponent: GraphicComponentTypes = 'fill_ugc',

): IComponentTemplate => {
    const recipe: IComponentTemplate = {
        material_type: 'graphic',
        swatch_id: graphic.id,
        group: 'graphics',
        subgroup: getSwatchSubgroup(graphic.id),
        sub_components: {}
    }

    for (let prop in graphic.component) {
        recipe.sub_components![graphic.component[prop].id] = {
            material_type: 'svg',
            swatch_id: graphic.component[prop].swatch_id,
            group: forceUGC && graphic.component[prop].id === ugcComponent ? 'ugc' : 'solids',
            subgroup: forceUGC && graphic.component[prop].id === ugcComponent ? 'ugc' : 'solids-apparel',
            toolkit_options: graphic.component[prop].id === ugcComponent && toolkitOptions
                ? toolkitOptions
                : {
                    hex: graphic.component[prop].hex ?? '#000000'
                }
        }
        if (ugc && graphic.component[prop].id === ugcComponent) {
            recipe.sub_components![graphic.component[prop].id]!.ugc = ugc
        }
    }

    return recipe;
}

export default RecipeCreateFromGDM;
